import { FileLinkField } from 'admin/fields/FileLinkField';
import { ClientInput } from 'admin/inputs/ClientInput';
import { BooleanInput, Edit, Labeled, RadioButtonGroupInput, SimpleForm } from 'react-admin';

import { REPORT_TYPE_CHOICES } from './reportUtils';

export const ReportEdit: React.FC = () => (
  <Edit mutationMode="pessimistic">
    <SimpleForm>
      <ClientInput disabled={true} label="Klient" source="client.id" />
      <RadioButtonGroupInput
        choices={REPORT_TYPE_CHOICES}
        disabled={true}
        label="Typ"
        source="type"
        sx={{ width: '40em' }}
      />
      <Labeled>
        <FileLinkField label="Výstup" source="file.id" />
      </Labeled>
      <BooleanInput defaultValue={false} label="Publikovať" source="published" />
    </SimpleForm>
  </Edit>
);
